import React from "react";
import {observer} from "mobx-react";
import {CollectorToModel, Prefix, PrefixIndex, useIndex} from "@morningtrain/react-resources";
import RepeaterSegmentHead from "./RepeaterSegmentHead";
import RepeaterSortableElement from "./RepeaterSortableElement";
import {FieldContext} from "@morningtrain/react-fields";

function RepeaterSegment(props) {

    const index = useIndex();
    const field = React.useContext(FieldContext);

    const segment = (
        <div className={'repeater-field-entry'}>
            <Prefix name={field.name}>
                <PrefixIndex>
                    <CollectorToModel>
                        <RepeaterSegmentHead itemHeader={props.itemHeader} extraHeaderActions={props.extraHeaderActions}/>
                    </CollectorToModel>
                    {props.children}
                </PrefixIndex>
            </Prefix>
        </div>
    );

    if (field.draggable === false) {
        return segment;
    }

    return (
        <RepeaterSortableElement index={index}>
            {segment}
        </RepeaterSortableElement>
    );
}

RepeaterSegment.defaultProps = {
    itemHeader: null,
    extraHeaderActions: null
};

export default observer(RepeaterSegment);
